/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PreviewSavedCommoditiesUploadRequest
 */
export interface PreviewSavedCommoditiesUploadRequest {
  /**
   *
   * @type {string}
   * @memberof PreviewSavedCommoditiesUploadRequest
   */
  companyId: string;
  /**
   *
   * @type {string}
   * @memberof PreviewSavedCommoditiesUploadRequest
   */
  base64Data: string;
}

/**
 * Check if a given object implements the PreviewSavedCommoditiesUploadRequest interface.
 */
export function instanceOfPreviewSavedCommoditiesUploadRequest(
  value: object,
): value is PreviewSavedCommoditiesUploadRequest {
  if (!("companyId" in value) || value["companyId"] === undefined) return false;
  if (!("base64Data" in value) || value["base64Data"] === undefined)
    return false;
  return true;
}

export function PreviewSavedCommoditiesUploadRequestFromJSON(
  json: any,
): PreviewSavedCommoditiesUploadRequest {
  return PreviewSavedCommoditiesUploadRequestFromJSONTyped(json, false);
}

export function PreviewSavedCommoditiesUploadRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PreviewSavedCommoditiesUploadRequest {
  if (json == null) {
    return json;
  }
  return {
    companyId: json["companyId"],
    base64Data: json["base64Data"],
  };
}

export function PreviewSavedCommoditiesUploadRequestToJSON(
  json: any,
): PreviewSavedCommoditiesUploadRequest {
  return PreviewSavedCommoditiesUploadRequestToJSONTyped(json, false);
}

export function PreviewSavedCommoditiesUploadRequestToJSONTyped(
  value?: PreviewSavedCommoditiesUploadRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyId: value["companyId"],
    base64Data: value["base64Data"],
  };
}
